export default {
  home: {
    title: "Outbox Messages",
  },
  empty: "No outbox messages",
  refresh: "Refresh outbox",
  filters: {
    allStatuses: "All statuses",
    eventType: "Event type…",
    tenant: "Tenant ID…",
  },
  status: {
    pending: "Pending",
    sent: "Sent",
    failed: "Failed",
    dead: "Dead",
  },
  fields: {
    status: "Status",
    eventType: "Event type",
    targetUrl: "Target URL",
    attempts: "Attempts",
    lastError: "Last error",
    tenant: "Tenant",
    created: "Created",
    nextRetry: "Next retry",
  },
  actions: {
    retry: {
      label: "Retry now",
      success: "Retry triggered",
    },
    delete: {
      label: "Delete",
      title: "Delete outbox message",
      confirm: 'Delete "%{name}"? This cannot be undone.',
      success: "Message deleted",
    },
  },
};
